<form>
  <mat-form-field appearance="fill">
    <mat-label>Enter your email</mat-label>
    <input matInput required [formControl]='username' (ngModelChange)="formChange()" autocomplete="username">
    <mat-error *ngIf="username.invalid">{{getUserErrorMessage()}}</mat-error>
  </mat-form-field>

  <br>

  <mat-form-field appearance="fill">
    <mat-label>Enter your passsword</mat-label>
    <input matInput type="password" required [formControl]='password' (ngModelChange)="formChange()"
      autocomplete="current-password">
  </mat-form-field>

  <br>

  <div class="buttonbar">
    <div class="errormessage" *ngIf="errorMessage">{{errorMessage}}</div>
    <button mat-raised-button color="primary" (click)="login()">Login</button>
  </div>

</form>
